module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-instagram-c613daac006e63f895b362fc90647c3f.png";